import { TextField } from '@mui/material';

import { withAutoSaveProvider } from '../hocs/AutoSaveProvider';
import { withDebounce } from './../hocs/DebounceProvider';

const AutoSaveTextField = withDebounce(withAutoSaveProvider(TextField));

export default AutoSaveTextField;
